import { useEffect, useState } from 'react';

export function usePersistedState<T = any>(
    key: string,
    defaultState: T
): [T, (value: T) => Promise<void>] {
    const [state, setState] = useState<T>(JSON.parse(localStorage.getItem(key) ?? 'null') ?? defaultState);

    useEffect(() => {
        async function getData() {
            const savedItem = localStorage.getItem(key);
            if (savedItem) {
                setState(JSON.parse(savedItem) ?? defaultState);
            }
        }
        getData();
    }, []);

    useEffect(() => {
        async function getData() {
            const savedItem = localStorage.getItem(key);
            if (savedItem) {
                setState(JSON.parse(savedItem ?? ''));
            }
        }
        getData();
    }, [key]);

    async function saveData(newValue: T) {
        localStorage.setItem(key, JSON.stringify(newValue));
        setState(newValue);
    }

    return [state, saveData];
}